/**
 * 统一日志工具
 * 仅在开发环境输出日志，生产环境自动禁用
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * 普通日志（仅开发环境）
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * 警告日志（仅开发环境）
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * 错误日志（始终输出）
   */
  error: (...args) => {
    console.error(...args);
  },

  /**
   * 信息日志（仅开发环境）
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * 调试日志（仅开发环境）
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

export default logger;
